<ng-container *ngIf="!game?.sub_jogos">
    <nb-card>
        <nb-card-body>
            <div class="match-participants" *ngIf="registers?.tenistas">
                <div class="match-participant">
                    <div class="match-participant-avatar">
                        <img [src]="registers.tenistas[0].url_avatar" [alt]="registers.tenistas[0].nome" />
                    </div>
                    <p class="match-participant-name">{{ registers.tenistas[0].nome }}</p>
                </div>
                <div class="match-participants-vs">
                    <span>- vs -</span>
                </div>
                <div class="match-participant">
                    <div class="match-participant-avatar">
                        <img [src]="registers.tenistas[1].url_avatar" [alt]="registers.tenistas[1].nome" />
                    </div>
                    <p class="match-participant-name">{{ registers.tenistas[1].nome }}</p>
                </div>
            </div>
            <div *ngIf="registers?.indicadores" class="mt-3">
                <nb-progress-bar
                    *ngIf="registers?.indicadores[6]"
                    status="success"
                    size="tiny"
                    [value]="registers.indicadores[6].perform.lado_1"
                ></nb-progress-bar>
                <div class="d-flex justify-content-between align-items-center mt-3">
                    <span class="paragraph-2">{{ registers.indicadores[6].perform.lado_1 }}</span>
                    <span class="text-center caption mb-0">{{ registers.indicadores[6].label }}</span>
                    <span class="paragraph-2">{{ registers.indicadores[6].perform.lado_2 }}</span>
                </div>
            </div>
        </nb-card-body>
        <div class="indicators px-4">
            <div
                class="d-flex justify-content-between align-items-center my-2"
                *ngFor="let indicator of registers?.indicadores"
            >
                <span>{{ indicator.perform.lado_1 }}</span>
                <span>{{ indicator.label }}</span>
                <span>{{ indicator.perform.lado_2 }}</span>
            </div>
        </div>
    </nb-card>
</ng-container>

<ng-container *ngIf="game?.sub_jogos">
    <div class="team-matches">
        <nb-card *ngFor="let game of game.sub_jogos" class="mt-3">
            <nb-card-body>
                <div class="game-match-container">
                    <div class="team">
                        <div class="team-info">
                            <img [src]="participantes['1'].url_avatar" [alt]="participantes['1'].nome" />
                            <p class="team-name">{{ participantes["1"].nome }}</p>
                        </div>
                        <div class="player-section">
                            <div class="player-avatar-container">
                                <div class="player-avatar" *ngFor="let participant of game.participantes['1']">
                                    <img [src]="participant.url_avatar" [alt]="participant.nome_abreviado" />
                                </div>
                            </div>
                            <div class="player-name" *ngFor="let participant of game.participantes['1']">
                                {{ participant.nome_abreviado }}
                            </div>
                        </div>
                    </div>
                    <div class="player-scores">
                        <div
                            class="score-box"
                            *ngFor="let resultado of game.resultados"
                            [class.winner]="getWinner1(resultado)"
                        >
                            {{ resultado.resultado_1 }}
                        </div>
                    </div>

                    <div class="match-separator"></div>
                    <div class="player-scores">
                        <div
                            class="score-box"
                            *ngFor="let resultado of game.resultados"
                            [class.winner]="getWinner2(resultado)"
                        >
                            {{ resultado.resultado_2 }}
                        </div>
                    </div>

                    <div class="team">
                        <div class="team-info team-info-2">
                            <img [src]="participantes['2'].url_avatar" [alt]="participantes['2'].nome" />
                            <p class="team-name">{{ participantes["2"].nome }}</p>
                        </div>
                        <div class="player-section">
                            <div class="player-avatar-container">
                                <div class="player-avatar" *ngFor="let participant of game.participantes['2']">
                                    <img [src]="participant.url_avatar" [alt]="participant.nome_abreviado" />
                                </div>
                            </div>
                            <div class="player-name" *ngFor="let participant of game.participantes['2']">
                                {{ participant.nome_abreviado }}
                            </div>
                        </div>
                    </div>
                </div>
            </nb-card-body>
        </nb-card>
    </div>
</ng-container>
